<template>
	<div>
		<LoaderWrapper class="invited-users-list" :isLoading="isEmpty && isLoading">
			<UserDataList :users="membersAlreadySharedWith" :sharedData="sharedProjectData.shared_users" :me="user" :projectId="projectId" />
			<GroupDataList :groups="groupsAlreadySharedWith" :sharedData="sharedProjectData.shared_groups" :projectId="projectId" />
			<div v-if="isEmpty && !isLoading" class="flex-centerize flex-column height-100">
				<div class="font-size-lg font-weight-600">If this is good, why not collaborate with others?</div>
				<EmptyStateSvg />
			</div>
		</LoaderWrapper>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
import { teamMembers } from '@/store/modules/account/getters';
import { projectSharedData, projectSharedDataLoading } from '@/store/modules/projects/getters';
import { groups } from '@/store/modules/accountGroups/getters';

import UserDataList from './UserDataList';
import GroupDataList from './GroupDataList';

import EmptyStateSvg from '@/components/dialogs/ShareModuleDialog/assets/EmptyStateSvg.vue';

export default {
	name: 'ExistingCollaboratorsList',
	components: {
		UserDataList,
		GroupDataList,
		EmptyStateSvg,
	},
	props: {
		projectId: { type: Number },
		user: { type: Object },
	},
	computed: {
		...mapGetters([groups.fullPath, teamMembers.fullPath, projectSharedData.fullPath, projectSharedDataLoading.fullPath]),
		sharedProjectData() {
			return this[projectSharedData.fullPath](this.projectId) || {};
		},
		membersAlreadySharedWith() {
			return this[teamMembers.fullPath].filter((u) =>
				(this.sharedProjectData.shared_users || []).map((user) => user.id).includes(u.user_id)
			);
		},
		groupsAlreadySharedWith() {
			return this[groups.fullPath].filter((g) =>
				(this.sharedProjectData.shared_groups || []).map((group) => group.id).includes(Number(g.id))
			);
		},
		isEmpty() {
			return this.membersAlreadySharedWith.length === 0 && this.groupsAlreadySharedWith.length === 0;
		},
		isLoading() {
			return this[projectSharedDataLoading.fullPath];
		},
	},
};
</script>

<style scoped lang="scss">
.invited-users-list {
	padding: 0 24px;
	margin: 15px 0 0 0;
	font-size: 14px;
	min-height: 282px;
	max-height: 282px;
	overflow-y: auto;
	&.shorten {
		height: 220px;
	}
	::v-deep(.user-data-row),
	::v-deep(.group-data-row),
	::v-deep(.header-section) {
		padding-left: 6px;
		padding-right: 6px;
		color: #9e9e9e;
		font-weight: 300;
	}
}
</style>
